import { HTMLAttributes } from "react";
import "./Tag.css";
import { cn } from "@/lib/utils";

const Tag = ({
  variant,
  size,
  children,
  className,
}: HTMLAttributes<HTMLDivElement> & {
  variant:
    | "pink"
    | "teal"
    | "yellow"
    | "blue"
    | "green"
    | "violet"
    | "active-color"
    | "default-color"
    | "grey";
  size: "m" | "s" | "floating";
  children: React.ReactNode;
  className?: string;
}) => {
  const baseClass = "tag";
  const variantClass =
    variant === "pink"
      ? "pink"
      : variant === "teal"
      ? "teal"
      : variant === "yellow"
      ? "yellow"
      : variant === "blue"
      ? "blue"
      : variant === "green"
      ? "green"
      : variant === "violet"
      ? "violet"
      : variant === "active-color"
      ? "active-color"
      : variant === "default-color"
      ? "default-color"
      : variant === "grey"
      ? "grey"
      : "base";
  const sizeClass =
    size === "m"
      ? "tag-m"
      : size === "s"
      ? "tag-s"
      : size === "floating"
      ? "floating-tag"
      : "";

  return (
    <div className={cn(`${baseClass} ${variantClass} ${sizeClass}`, className)}>
      {children}
    </div>
  );
};

export default Tag;
